import axios from "axios";
import { ProductPaginated } from "../../products-page/components/products-searched-view/models";

export const getOtherDistributorProducts = (productId: string) => {
    return axios.get<ProductPaginated>('products/otherDistributorProducts/' + productId)
}



